<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('seller') }}</v-card-title>
        <v-card-text class="pb-0">
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.sellerName"
                        :label="$t('nameSurname')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.sellerEmail"
                        :label="$t('email')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        class="py-0 my-0"
                        :value="orderData.sellerPhone"
                        :label="$t('phone')"
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"

export default {
    name: "ExtendSellerInfo",
    mixins: [OrderExtendInfo],
}
</script>
